import { hooks } from "../setupHooks.mjs";
const setElementProps = node => {
  hooks.setElementProps?.(node);
};
export { setElementProps };
//# sourceMappingURL=setElementProps.mjs.map
